import { AfterViewInit, Component, ElementRef, inject, Input, Output, Renderer2, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { EventEmitter } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { RecaptchaIntegrator } from '@app/services/recaptcha-integrator/recaptcha-integrator.service';

@Component({
  standalone: true,
  selector: 'app-recaptcha-render',
  templateUrl: './recaptcha-render.component.html',
  styleUrls: ['./recaptcha-render.component.scss'],
})
export class RecaptchaRenderComponent implements AfterViewInit {
  @Input()
  public recaptcha: any;
  @Input()
  public isDialog: Boolean;
  @Input()
  public form: FormGroup;
  @Input()
  private dialogRef: MatDialogRef<any>;
  @Output()
  public sendTokenEvent = new EventEmitter();
  @Output()
  public sendError = new EventEmitter();
  @Output()
  public expiredToken = new EventEmitter();

  @ViewChild('contentCaptcha')
  container: ElementRef;

  public error: Boolean = false;
  private renderer = inject(Renderer2);
  private recaptchaIntegrator = inject(RecaptchaIntegrator);

  ngAfterViewInit() {
    if (!this.recaptchaIntegrator.usingCaptcha(this.recaptcha)) {
      return;
    }
    if (this.recaptcha.type == 'checkbox') {
      if (this.isDialog) {
        this.dialogRef.updateSize('500px', '430px');
      }
      const widget = this.createElement();
      const baseOptions = {
        sitekey: this.recaptcha.token,
        'expired-callback': () => this.expired(),
        'error-callback': () => this.errored([]),
        'callback': (e: string) => this.resolved(e)
      };
      this.recaptchaIntegrator.renderV2(widget, baseOptions)
    }
  }

  createElement() {
    const widgets = document.getElementById("g-response-widgth");
    const widget = document.createElement('div');
    widgets.appendChild(widget);
    return widget;
  }

  generateToken() {
    return this.recaptchaIntegrator.generateToken().then(token => token).catch(() => false);
  }

  expired() {
    this.expiredToken.emit();
  }

  resolved(token: string) {
    this.sendTokenEvent.emit(token);
  }

  errored(event: any) {
    console.error("Error rendering reCAPTCHA", event);
    this.error = true;
    this.dialogRef.updateSize('500px', '350px');
    this.renderer.addClass(this.container.nativeElement, 'hidden');
    this.sendError.emit(event);
  }

  reset() {
    window['grecaptcha'].reset();
  }
}
